<script>
import { mapActions, mapGetters } from 'vuex'
import formatDateMixin from '@/mixins/formatDateMixin'
export default {
  name: 'CandidateCertifications',
  mixins: [formatDateMixin],
  props: {
    timeZone: {
      type: String,
      default: null,
    },
    certifications: {
      type: Array,
      default: null,
    },
  },
  data: () => {
    return {
      loaderIndex: -1,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'file/isLoading',
    }),
  },
  methods: {
    ...mapActions({
      download: 'file/download',
    }),

    async downloadFile(fileId, i) {
      this.loaderIndex = i
      await this.download(fileId)
    },
  },
}
</script>

<template>
  <v-card flat>
    <v-simple-table class="pa-10">
      <template v-slot>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Verified Date</th>
            <th class="text-left">Certification Number</th>
            <th class="text-left">Downloads</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(cert, i) in certifications"
            :key="`candidateCertifications_certs_${cert.certId}_${i}`"
          >
            <td>{{ cert.typeName }}</td>
            <td class="font-monospace">
              {{ renderDate(cert.verifiedDate, timeZone) }}
            </td>
            <td class="font-monospace">{{ cert.certRefNo }}</td>
            <td class="text-center">
              <v-col
                v-for="(file, fi) in cert.files"
                :key="`candidateCertifications_files_${file.fileId + fi}`"
                cols="1"
                class="pa-1"
              >
                <v-btn
                  :key="`candidateCertifications_files_${file.fileId + fi}`"
                  value="file.fileId"
                  x-small
                  text
                  color="primary"
                  :loading="isLoading && file.fileId + fi === loaderIndex"
                  @click="downloadFile(file.fileId, file.fileId + fi)"
                >
                  <v-icon left dark>
                    mdi-cloud-download
                  </v-icon>
                  <span class="hidden-sm-and-down">File {{ fi + 1 }}</span>
                </v-btn>
              </v-col>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>
